module.exports = __webpack_public_path__ + "img/bgSp.be5e7b8b.jpg";